<p-confirmDialog></p-confirmDialog>

<p-accordion value="mfa-0" [multiple]="true" class="flex flex-col gap-2 py-4">
  <ng-container *ngFor="let tab of getChildren(); let i = index">
    <div class="flex flex-1 items-start justify-center gap-2">
      <p-accordion-panel [value]="'mfa-' + i" class="flex-1" [attr.data-panel-id]="'mfa-' + i">
        <p-accordion-header class="p-accordion-header">
          <div class="flex flex-row items-center justify-between w-full">
            <span class="underline">
              {{ (accordionObject?.titles?.[0] || '' | translate) + ' ' + (i + 1) }}
            </span>
            <button type="button" class="mx-5" pTooltip="Retirer" tooltipPosition="top"
              [disabled]="(isTabDisabled(i) | async) || (accordionObject?.isDisabled | async) || (getChildren().length <= 1 && (accordionObject?.allowEmpty | async) === false)"
              (click)="$event.stopPropagation(); confirmRemove($event, getNextLevel(i))">
              <i class="pi pi-eraser text-xl" [ngClass]="{
                  'text-red-500': getChildren().length > 1 && (isTabDisabled(i) | async) === false && (accordionObject?.isDisabled | async) === false && (accordionObject?.allowEmpty | async) === false,
                  'text-gray-200 cursor-not-allowed':
                    (isTabDisabled(i) | async) || (accordionObject?.isDisabled | async) || (getChildren().length <= 1 && (accordionObject?.allowEmpty | async) === false),
                }"></i>
            </button>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <ng-container *ngIf="isLeaf(i); else branchContent">
            <ng-container [ngComponentOutlet]="accordionObject?.component"
              [ngComponentOutletInputs]="componentInputs(i)"> </ng-container>
          </ng-container>
          <ng-template #branchContent>
            <sm-multi-form-accordion [accordionObject]="getChildAccordionObject(i)" [parentIndexes]="getNextLevel(i)">
            </sm-multi-form-accordion>
          </ng-template>
        </p-accordion-content>
      </p-accordion-panel>
    </div>
  </ng-container>
</p-accordion>

<div class="flex justify-between items-center">
  <p-button
  *ngIf="!accordionObject?.disableItemAddition"
    type="button"
    [label]="
      accordionObject?.titles?.[0]
        ? ('common.multi_form_accordion.add_entity' | translate: { entity: (accordionObject?.titles?.[0] || '' | translate) })
        : ('common.multi_form_accordion.add' | translate)
    " (onClick)="add(parentIndexes)" [disabled]="(accordionObject?.isDisabled | async)">
    <i class="pi pi-plus"></i>
  </p-button>
  <ng-container [ngComponentOutlet]="accordionObject?.downSyndromeComponent"
    [ngComponentOutletInputs]="accordionObject?.downSyndromeProps"></ng-container>
</div>

<!-- Debug Button Made to show all data in the store at each level -->
<!-- <div>
  <p-button type="button" label="Show All Data" (onClick)="logAllStores()"></p-button>
</div> -->